// src/app/dashboard/layout.tsx

"use client";

import type React from "react";
import BottomNav from "@/components/mobile/BottomNav";

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      {/* Mobile bottom navigation - padding to prevent content being hidden behind it */}
      <div className="lg:hidden h-20" />
      <BottomNav />
    </>
  );
}
